import VideoPlayer from '@/components/videoPlayer/videoPlayer';
import Modal, { ModalProps } from 'react-bootstrap/Modal';
import './videoModal.scss';
import Button from '@/components/button/button';
import { VscClose } from 'react-icons/vsc';

interface VideoModalProps extends ModalProps {
  videoUrl: string;
}
const VideoModal: React.FC<VideoModalProps> = ({ videoUrl, ...props }) => {
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="video-modal-title"
        aria-describedby="video-modal-description"
        centered
        className="video-modal"
      >
        <Modal.Body className="video-modal-body">
          <Button variant="text" onClick={props.onHide} className="close-btn">
            <VscClose aria-hidden="true" />
          </Button>
          <VideoPlayer url={videoUrl} />
        </Modal.Body>
      </Modal>
    </>
  );
};
export default VideoModal;
